




























import { Component, Vue } from 'vue-property-decorator'
import ActivityList from '@/components/ActivityList.vue'
import EditActivityDialog from '@/components/EditActivityDialog.vue'
import UserDrawer from '@/components/UserDrawer.vue'

@Component({
  components: { ActivityList, EditActivityDialog, UserDrawer }
})
export default class UserDashboard extends Vue {
  $refs: any = {
    editActivityDialog: EditActivityDialog
  }

  get accountEmail (): string {
    return this.$store.state.account.email
  }

  get isAdmin (): boolean {
    return this.$store.getters['account/isAdmin']
  }

  onActivitySelected (activity: any) {
    this.$refs.editActivityDialog.open(activity.id)
  }

  onAddActivityClicked () {
    this.$refs.editActivityDialog.open()
  }
}
